var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassDialog",
    {
      staticClass: "import-cancel-dialog",
      attrs: {
        size: "small",
        title: _vm.$t.__("settings.import.importCancelPopup.title"),
        visible: _vm.showDialog,
        secondaryActions: _vm.secondaryAction,
        primaryAction: _vm.primaryAction
      },
      on: {
        "update:visible": function($event) {
          _vm.showDialog = $event
        },
        closed: function($event) {
          return _vm.$emit("closed")
        }
      }
    },
    [
      [
        _c("div", { staticClass: "typographies-paragraph-medium-regular" }, [
          _vm._v(
            "\n            " +
              _vm._s(
                _vm.$t.__("settings.import.importCancelPopup.description")
              ) +
              "\n        "
          )
        ])
      ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }